var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 20,
    viewBox: "0 0 15 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1671 0H0.832457C0.373282 0 0 0.360767 0 0.805012V19.1931C0 19.5539 0.230782 19.8562 0.587752 19.962C0.947602 20.0677 1.31225 19.9444 1.52192 19.6448L7.37981 11.2952C7.45466 11.1876 7.54487 11.1876 7.61971 11.2952L13.4781 19.6448C13.6383 19.8729 13.8893 20 14.1584 20C14.2419 20 14.3268 19.9879 14.4118 19.962C14.7692 19.8562 15 19.5539 15 19.1931V0.805012C15 0.360777 14.6263 0 14.1671 0ZM10.0456 2.85463H9.0145C8.8245 2.85463 8.67048 2.70624 8.67048 2.52261C8.67048 2.33897 8.8245 2.19059 9.0145 2.19059H10.0456C10.2356 2.19059 10.3896 2.33897 10.3896 2.52261C10.3896 2.70624 10.2356 2.85463 10.0456 2.85463ZM7.69553 2.85463H2.74781C2.55781 2.85463 2.40379 2.70624 2.40379 2.52261C2.40379 2.33897 2.55781 2.19059 2.74781 2.19059H7.69553C7.88553 2.19059 8.03955 2.33897 8.03955 2.52261C8.03955 2.70624 7.88553 2.85463 7.69553 2.85463Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmark);
export default __webpack_public_path__ + "static/media/bookmark.c2178bf87e70a458757ba7290cea3ce7.svg";
export { ForwardRef as ReactComponent };